<template>
  <el-dialog
    title="添加表单协作人员"
    :visible.sync="value.visible"
    width="700px"
    append-to-body
    :destroy-on-close="true"
    @open="onDlgOpen"
  >
    <div class="py-2_5">
      <div class="mb-2_5">输入用户ID或手机号添加成员，将从公海（全站）搜索用户</div>
      <el-input v-model="account" class="my-2_5" placeholder="输入用户ID或手机号" />
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="onCancel">取 消</el-button>
      <el-button type="primary" :loading="$store.state.app.loadingList.includes('createFormUser')" @click="onOk">确 定</el-button>
    </span>
  </el-dialog>

</template>

<script>
import { createFormUser } from '@/api/form'

export default {
  name: 'DlgAddFormUser',
  components: {
  },
  props: {
    // 原则上vue的props应该是只读的，但vue对对象中的内容没有监测，这里不管了，直接把modelValue当作可写的
    value: {
      type: Object,
      default: () => ({
        visible: false
      })
    },
    params: {
      type: Object,
      default: () => ({
        formId: ''
      })
    }
  },
  emits: ['ok', 'cancel'],
  data() {
    return {
      account: ''
    }
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  mounted() {
    console.log(this.value)
  },

  methods: {
    onDlgOpen() {
      this.account = ''
    },
    async saveForm() {
      const that = this

      const res = await createFormUser({
        form_id: that.params.formId,
        account: that.account
      }, 'createFormUser')
      console.log(res)

      return res
    },

    onCancel() {
      console.log('cancel')
      this.value.visible = false
      this.$emit('cancel')
    },
    async onOk() {
      const that = this
      console.log('ok')
      if (!that.account) return

      await that.saveForm()
      that.value.visible = false
      that.$emit('ok', this.value)
      // await this.$refs['dlgForm'].validate(async(valid, fields) => {
      //   if (valid) {
      //     this.value.visible = false
      //     await that.saveAppForm()
      //     that.$emit('ok', this.value)
      //   } else {
      //     console.log('error submit!', fields)
      //   }
      // })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped></style>
